import type { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faBolt, faBullhorn, faChartLineUp, faUserGroup } from '@fortawesome/pro-regular-svg-icons';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface IFeatureCardConfig {
  /** Icon to display in the card */
  icon: IconDefinition;
  /** Title/label for the feature */
  label: string;
  /** Description of the feature */
  description: string;
  /** Unique name for the card element */
  name: string;
}

export function useMetaFeatureCards(): IFeatureCardConfig[] {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        icon: faBullhorn,
        label: t('Create & Manage Campaigns'),
        description: t(
          'Build and optimize Facebook and Instagram ad campaigns directly from your dashboard',
        ),
        name: 'feature-card-campaigns',
      },
      {
        icon: faChartLineUp,
        label: t('Track Performance'),
        description: t('Monitor ad performance with real-time metrics and comprehensive analytics'),
        name: 'feature-card-performance',
      },
      {
        icon: faUserGroup,
        label: t('Audience Management'),
        description: t("Leverage Meta's powerful targeting options to reach your ideal customers"),
        name: 'feature-card-audience',
      },
      {
        icon: faBolt,
        label: t('Automated Workflows'),
        description: t('Streamline your social advertising with automated campaign optimization'),
        name: 'feature-card-workflows',
      },
    ],
    [t],
  );
}
